import React from "react";
import { useSelector } from "react-redux";
import Select, { components } from "react-select";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface Props {
  handleChangeOrder: (x: any) => void;
  collaborators: any;
  handleCollabChange: any;
  handlerType: (x: any) => void;
  handleChangeDeliveryDate: (x: any) => void;
}

export const AddOrderBottomDrawer = ({
  handleChangeOrder,
  collaborators,
  handleCollabChange,
  handlerType,
  handleChangeDeliveryDate,
}: Props) => {
  const { user } = useSelector((state: any) => state.auth);
  
  const DropdownIndicator = (props: any) => {
    return (
      <components.DropdownIndicator {...props}>
        <FontAwesomeIcon icon={faCaretDown} />
      </components.DropdownIndicator>
    );
  };

  const options = [
    { value: "knit", label: "Knit" },
    { value: "denim", label: "Denim" },
  ];
  const customStylesCreateModern = {
    control: (base: any, state: any) => ({
      ...base,
      background: "white",
      borderColor: state.isFocused ? "#00468c" : "#e2e8f0",
      borderRadius: "8px",
      padding: "2px",
      fontSize: "14px",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#00468c",
      },
    }),
    placeholder: (base: any) => ({
      ...base,
      color: "#94a3b8",
    }),
    menu: (base: any) => ({
      ...base,
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
      border: "1px solid #e2e8f0",
      zIndex: 100
    }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected ? "#00468c" : state.isFocused ? "#f1f5f9" : "white",
      color: state.isSelected ? "white" : "#1e293b",
      padding: "10px 12px",
      fontSize: "14px",
      cursor: "pointer"
    }),
  };

  return (
    <div className="create_collection_form_modern" style={{ 
      padding: "24px", 
      borderRadius: "16px",
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      maxWidth: "800px",
      margin: "0 auto",
      width: "100%"
    }}>
      <h3 style={{ fontSize: "18px", fontWeight: 700, color: "#1e293b", margin: 0 }}>New Order</h3>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px" }}>
        {/* Left Column */}
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Name Your Order</label>
            <input
              type="text"
              name="name"
              id="orderName"
              placeholder="e.g. Bulk Order 2027"
              onChange={(e: any) => handleChangeOrder(e)}
              style={{ 
                border: "1px solid #e2e8f0", 
                borderRadius: "8px", 
                width: "100%", 
                outline: "none", 
                fontSize: "14px", 
                padding: "10px 14px",
                background: "white",
                transition: "border-color 0.2s"
              }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Delivery Date</label>
            <input
              type="date"
              name="delivery_date"
              id="delivery_date"
              onChange={handleChangeDeliveryDate}
              style={{ 
                border: "1px solid #e2e8f0", 
                borderRadius: "8px", 
                width: "100%", 
                outline: "none", 
                fontSize: "14px", 
                padding: "10px 14px",
                background: "white"
              }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Collaborators</label>
            <Select
              isMulti
              name="colors"
              placeholder="Search names..."
              options={
                collaborators &&
                collaborators.map((el: any) => ({
                  label: el.name,
                  value: el.id,
                }))
              }
              styles={customStylesCreateModern}
              onChange={handleCollabChange}
            />
          </div>
        </div>

        {/* Right Column */}
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Season</label>
            <input
              type="text"
              name="season"
              id="order_season"
              placeholder="e.g. FW27"
              onChange={(e: any) => handleChangeOrder(e)}
              style={{ 
                border: "1px solid #e2e8f0", 
                borderRadius: "8px", 
                width: "100%", 
                outline: "none", 
                fontSize: "14px", 
                padding: "10px 14px",
                background: "white"
              }}
            />
          </div>

          {user.fabric_type == "knit_denim" && (
            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
              <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Fabric Type</label>
              <Select
                name="type"
                placeholder="Select fabric..."
                styles={customStylesCreateModern}
                options={options}
                onChange={handlerType}
                components={{ DropdownIndicator }}
              />
            </div>
          )}

          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Details</label>
            <textarea
              name="details"
              id="details"
              placeholder="Any additional information..."
              onChange={(e: any) => handleChangeOrder(e)}
              rows={4}
              style={{ 
                border: "1px solid #e2e8f0", 
                borderRadius: "8px", 
                width: "100%", 
                outline: "none", 
                fontSize: "14px", 
                padding: "10px 14px",
                background: "white",
                resize: "none"
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
